import React, { Component, Suspense } from 'react';
import { Panel, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { navigate } from 'raviger';
import _ from 'lodash';

import * as constants from '../../../../constants';

import { breadcrumbAddRoute, breadcrumbRemoveRoute } from '../../../../store/actions/breadcrumb';
import { franchiseList } from '../../../../store/actions/franchise';
import { masterBlasterQueue } from '../../../../store/actions/masterBlaster';
import { lookupTypes } from '../../../../store/actions/utility';
import { alertAdd } from '../../../../store/actions/alert';

import OptionsHelper from '../../../../lib/OptionsHelper';
import Multiselect from 'multiselect-react-dropdown';
import InputCollection from '../../../../components/InputCollection/InputCollection';

import withAuthentication from '../../../../hoc/withAuthentication';
import withLayout from '../../../../hoc/withLayout';
import withForm from '../../../../hoc/withForm/withForm';

import Spinner from '../../../../components/Spinner/Spinner';

import { columns, sorting } from './MasterBlasterSchema';

import rules from './rules/base';

const SideMenu = React.lazy(() => import('../../../../components/SideMenu/SideMenu'));
const PageHeader = React.lazy(() => import('../../../../components/PageHeader/PageHeader'));
const FormInput = React.lazy(() => import('../../../../components/FormInput/FormInput'));
const UploadInput = React.lazy(() => import('../../../../components/UploadInput/UploadInput'));
const CancelButton = React.lazy(() => import('../../../../components/Buttons/CancelButton/CancelButton'));
const SaveButton = React.lazy(() => import('../../../../components/Buttons/SaveButton/SaveButton'));
const BaseList = React.lazy(() => import('../../../../components/Lists/BaseList/BaseList'));
const ConfirmationModal = React.lazy(() => import('../../../../components/Modals/ConfirmationModal/ConfirmationModal'));

const defaultValue = '';

class MasterBlaster extends Component {

    constructor(props) {
        super(props);
        this.franchiseDropdown = React.createRef();
    }

    state = {
        showConfirmModal: false,
        fileUrl: null,
        form: {
            franchiseIds: null,
            franchiseStaffId: '',
            file: null,
            message: ''
        },
        selectedRecords: [],
        canEdit: false,
        hasPermission: false,
        pagePermission: constants.PERMISSION_CONTENT_MASTERBLASTER,
        isMounted: false
    };

    componentDidMount() {
        this.props.onBreadcrumbAddRoute({ key: 'masterBlaster', parent: 'Content', text: 'Master Blaster', path: window.location.pathname });

        this.props.onLookupTypes('FranchiseStaff');
        if (_.isEmpty(this.props.franchises)) { this.props.onFranchiseList(); }
        this.setState({ isMounted: true });
    };

    componentWillMount() {
        this.props.permissions.filter((perm) => {
            if (perm.name === this.state.pagePermission) {
                this.setState({ hasPermission: true });
                if (perm.edit === true || perm.edit === 'true') {
                    this.setState({ canEdit: true });
                }
            }
        });
    };

    componentDidUpdate(prevProps) {
        if (this.props.lastState !== prevProps.lastState) {
            if (this.props.lastState === constants.STATE_FAIL) {
                if (this.props.lastScope === 'queue') {
                    this.props.formAlertFail(<span>Could not queue SMS messages.</span>);
                }
            } else {
                if (this.props.lastScope === 'queue' && this.props.lastState === constants.STATE_SUCCESS) {
                }
            }
        }

        if (prevProps.isValidated !== this.props.isValidated) {
            if (this.props.isValidated) {
                this.setState({ showConfirmModal: true });
            }
        }
    };

    componentWillUnmount() {
        this.props.onBreadcrumbRemoveRoute();
    };

    changedHandler = (id, value) => {
        const updatedState = { ...this.state };
        updatedState.form[id] = value;

        if (id !== 'franchiseIds') {
            this.setState(updatedState);
            this.props.formChanged();
        }
    };

    cancelledHandler = () => {
        navigate(`/dashboard`);
    };


    selectHandler = (list, _item) => {        
        let records = [];
        let reportValues = [];

        if (!_.isEmpty(list)) {
            list.forEach((record) => {
                records.push(record);
                reportValues.push(record.id.toString());
            });                        
        }
        this.setState({isDisabled: false});
        this.setState({selectedRecords: records});
    };

    removeHandler = (list, _item) => {        
        let records = [];
        let reportValues = [];

        if (!_.isEmpty(list)) {
            list.forEach((record) => {
                records.push(record);
                reportValues.push(record.id.toString());
            }); 
        }

        this.setState({selectedRecords: records});
    };

    validateHandler = () => {       
        if(this.state.selectedRecords){
            let franchiseIds = this.state.selectedRecords.map((selectedFranchise) => {
                return selectedFranchise.id;
            })
            this.state.form.franchiseIds = franchiseIds;
        }

        this.props.formValidate(this.state.form, rules); // Action from HOC
    };

    noClickHandler = () => {
        this.setState({ showConfirmModal: false });
    };

    yesClickHandler = () => {
        this.props.onMasterBlasterQueue({ data: this.state.form });
        this.setState({ showConfirmModal: false });
    };

    multiselectInput = (disabledProp) => {
        if (!this.props.franchises) {
            return null;
        }
        const stateOptionsList = this.props.franchises.filter(f => f.statusId === 1).map(this.multiselectMap, this);
        const franchisebuttons = (
            <div>
                <Button type="button" bsStyle="default" className="button-small-gray button-group-margin btn btn-danger" onClick={(e) => this.franchiseGroupSelect(e)}>Select All</Button>
                <Button type="button" bsStyle="default" className="button-small-gray button-group-margin btn btn-danger" onClick={(e) => this.franchiseGroupSelect(e)}>Corporate</Button>
                <Button type="button" bsStyle="default" className="button-small-gray button-group-margin btn btn-danger" onClick={(e) => this.franchiseGroupSelect(e)}>Non-Corporate</Button>
                <Button type="button" bsStyle="default" className="button-small-gray button-group-margin btn btn-danger" onClick={(e) => this.franchiseGroupSelect(e)}>By instance</Button>
            </div>
        );

        return (
            <>
                <InputCollection labelText='Instances' errorMessage={this.props.formValidationCheck('franchiseIds')}>
                    <Multiselect 
                        id='franchiseIds' 
                        options={stateOptionsList} 
                        avoidHighlightFirstOption={true} 
                        displayValue="name"  
                        placeholder={'Select Instances...'} 
                        emptyRecordMsg="No Records Available" 
                        selectedValues={this.state.selectedRecords} 
                        ref={this.franchiseDropdown} 
                        onSelect={(list, item) => this.selectHandler(list, item)} 
                        onRemove={(list, item) => this.removeHandler(list, item)} 
                    />
                </InputCollection>
                {franchisebuttons}
            </>
        );
    }

    multiselectMap = (x, i) => {
        let keyVal = {};
        keyVal["id"] = x.id;
        keyVal["name"] = `${x.instance} - ${x.name}`;
        keyVal["groupby"] = (x.corporateOwned === undefined) ? 'Unknown' : x.corporateOwned === true ? 'Corporate Owned' : 'Non-Corporate Owned';
        return keyVal;
    }

    franchiseGroupSelect = (e, t) => {
        let updatedState = { ...this.state };
        let filteredFranchises = [];
        let filteredFranchiseIds = [];
        if (e.currentTarget.innerHTML === "Select All") {
            filteredFranchiseIds = this.props.franchises.map((x, i, arr) => {
                return x.id;
            });
            filteredFranchises = this.props.franchises.map((x,i,arr) => {
                return {id: x.id, name: x.instance + ' - ' + x.name};
            });
        } else if (e.currentTarget.innerHTML === "Corporate") {
            filteredFranchiseIds = this.props.franchises.map((x, i, arr) => {
                return x.corporateOwned ? x.id : -1;
            });
            filteredFranchises = this.props.franchises.map((x,i,arr) => {
                return x.corporateOwned ?{id: x.id, name: x.instance + ' - ' + x.name}: -1;
            });
        } else if (e.currentTarget.innerHTML === "Non-Corporate") {
            filteredFranchiseIds = this.props.franchises.map((x, i, arr) => {
                return !x.corporateOwned ? x.id : -1;
            });
            filteredFranchises = this.props.franchises.map((x,i,arr) => {
                return !x.corporateOwned ? {id: x.id, name: x.instance + ' - ' + x.name}: -1;
            });
        } else if (e.currentTarget.innerHTML === "By instance") {
            filteredFranchiseIds = this.props.franchises.map((x, i, arr) => {
                return x.corporateOwned && x.instance !== 'HS0041' ? x.id : -1;
            });
            filteredFranchises = this.props.franchises.map((x, i, arr) => {
                return x.corporateOwned && x.instance !== 'HS0041' ? {id: x.id, name: x.instance + ' - ' + x.name}: -1;
            });
        }
        updatedState.form["franchiseIds"] = filteredFranchiseIds.filter(function (value) { return value !== -1 });
        let filterTo = filteredFranchises.filter(function (value) { return value !== -1 });

        updatedState.selectedRecords = filterTo;
        this.setState(updatedState);
        this.props.formChanged();
    }

    render() {
        const isSaving = this.props.lastState === constants.STATE_PROCESSING;
        const disabledProp = (isSaving) && { disabled: true };
        const franchiseStaffOptions = OptionsHelper({ list: this.props.franchiseStaff, defaultOptions: [['-1', 'All Recipients'], ['-2', 'All Agents']], includeBlank: true });

        var uploadModal = null;
        let confirmModal = null;

        if (this.state.showConfirmModal) {
            confirmModal = (<ConfirmationModal
                show={this.state.showConfirmModal}
                noClicked={this.noClickHandler}
                yesClicked={this.yesClickHandler}
                noText="No, do not queue these!"
                yesText="Yes, go ahead and queue these!"
                title="Queue SMS messages for sending?">
                <p>You are about to queue SMS messages to be sent. Queueing these messages can take up to 5 mins. SMS Text Messaging rates will apply.<br /><br />
                    Once this process begins, it can not be aborted. Continue?</p>
            </ConfirmationModal>);
        }

        const styles = {
            display: 'flex',
            justifyContent: 'center',
            marginBottom: '3em',
            marginTop: '3em',
            border: 0,
        };

        return (
            <>
                {this.state.hasPermission && this.state.isMounted &&
                    <Suspense fallback={<Spinner text="Loading..." />}>
                        <SideMenu activeKey="content" />
                        <div className="content-body">
                            {uploadModal}
                            {confirmModal}
                            <div style={{ paddingRight: '15px' }}>
                                <PageHeader title="Master Blaster" />
                                <Panel>
                                    {
                                        _.isEmpty(this.props.franchises)
                                            ? <Spinner text="Loading..." />
                                            : <Panel.Body>
                                                <div className="row" style={{ marginBottom: '1rem' }}>
                                                    <div className={this.props.formValidationCheck('franchiseIds') ? "col-md-12 has-error" : "col-md-12"}>
                                                        {this.multiselectInput(disabledProp)}
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <FormInput id="franchiseStaffId"
                                                            required
                                                            helpText="Send SMS text messages to the following recipients of the instances."
                                                            type="select"
                                                            labelText="Instance Recipients"
                                                            errorMessage={this.props.formValidationCheck('franchiseStaffId')}
                                                            value={this.state.form.franchiseStaffId || defaultValue}
                                                            changed={(id, value) => this.changedHandler(id, value)}
                                                            {...disabledProp}>
                                                            {franchiseStaffOptions}
                                                        </FormInput>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <UploadInput id="file"
                                                            labelText="Image"
                                                            helpText="An image to send along with the SMS text."
                                                            errorMessage={this.props.formValidationCheck('file')}
                                                            value={this.state.form.file || defaultValue}
                                                            changed={(id, value) => this.changedHandler(id, value)}
                                                            {...disabledProp} />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <FormInput id="message"
                                                            required
                                                            labelText="SMS Message"
                                                            autoComplete="off"
                                                            errorMessage={this.props.formValidationCheck('message')}
                                                            type="textarea"
                                                            rows="10"
                                                            value={this.state.form.message || defaultValue}
                                                            maxLength={3000}
                                                            changed={(id, value) => this.changedHandler(id, value)}
                                                            {...disabledProp} />
                                                    </div>
                                                </div>
                                                <hr className="form-divider" />
                                                <div className="form-action-buttons">
                                                    <CancelButton className="button-group-margin" text="Back" clicked={this.cancelledHandler} {...disabledProp} />
                                                    {this.state.canEdit &&
                                                        <SaveButton className="button-group-margin" saving={isSaving} text="Blast Off!" clicked={this.validateHandler} {...disabledProp} />
                                                    }
                                                </div>
                                            </Panel.Body>
                                    }
                                </Panel>
                                <Panel>
                                    <Panel.Body>
                                        <div className="row" style={{ paddingTop: '20px' }}>
                                            <div className="col-md-12">
                                                <BaseList
                                                    compType="Queue"
                                                    listData={this.props.queue}
                                                    sorting={sorting}
                                                    columns={columns}
                                                    permissionEdit={this.state.canEdit}
                                                    hideAdd={true}
                                                    hideCopy={true}
                                                    hidePrint={true}
                                                    hideFilter={true}
                                                    hideDelete={true}
                                                    hideRefresh={true}
                                                    hideEdit={true} />
                                            </div>
                                        </div>
                                    </Panel.Body>
                                </Panel>
                            </div>
                        </div>
                    </Suspense>
                }
                {!this.state.hasPermission && this.state.isMounted &&
                    <React.Fragment>
                        <div style={{ ...styles }}>
                            <div>
                                <h3>Access Denied</h3>
                            </div>
                        </div>
                    </React.Fragment>
                }
            </>

        );
    }
};

const mapStateToProps = (state) => ({
    franchiseStaff: state.utility.lookupTypeFranchiseStaff,
    franchises: state.franchise.franchises,
    queue: state.masterBlaster.queue,
    lastState: state.masterBlaster.lastState,
    lastScope: state.masterBlaster.lastScope,
    permissions: state.authentication.permissions
});

const mapDispatchToProps = (dispatch) => ({
    onFranchiseList: (options) => dispatch(franchiseList(options)),
    onMasterBlasterQueue: (options) => dispatch(masterBlasterQueue(options)),
    onBreadcrumbAddRoute: (crumb) => dispatch(breadcrumbAddRoute(crumb)),
    onBreadcrumbRemoveRoute: (crumb) => dispatch(breadcrumbRemoveRoute(crumb)),
    onLookupTypes: (category) => dispatch(lookupTypes(category)),
    onAlertAdd: (alert) => dispatch(alertAdd(alert))
});

export default withLayout(withAuthentication(connect(mapStateToProps, mapDispatchToProps)(withForm(MasterBlaster, rules))));
